import { FlowOperationController } from '@/api/flowController.js';
import projectConfig from '@/core/config';

// 催办消息轮询间隔 60s
const MESSAGE_TIMER_INTERVAL = 1000 * 60 * 1;
import state from "@/store/state";
import Notify from '@wcjiang/notify';

const notify = new Notify({
  message: '消息通知内容',
  effect: 'flash',
  openurl: `${projectConfig.onlineUrl}/#/main/welcome?type=remindingMessage`,
  onclick: () => {
    notify.close()
  },
  audio: {
    file: ['msg.mp3']
  },
  interval: 1000,
  disableFavicon: false,
  updateFavicon: {
    textColor: '#fff',
    backgroundColor: '#2F9A00'
  },
  notification: {
    title: '通知!',
    icon: '',
    body: '你有一个待处理消息！'
  }
})
// 未读邮件
const EmailNotify = new Notify({
  message: '消息通知内容',
  effect: 'flash',
  openurl: `${projectConfig.onlineUrl}/#/main/welcome?type=email`,
  onclick: () => {
    EmailNotify.close()
  },
  audio: {
    file: ['msg.mp3']
  },
  interval: 1000,
  disableFavicon: false,
  updateFavicon: {
    textColor: '#fff',
    backgroundColor: '#2F9A00'
  },
  notification: {
    title: '通知!',
    icon: '',
    body: '你有一封未读邮件！'
  }
})
// 获得消息列表数据
function loadMessage (context, owner) {
  FlowOperationController.getMessageCount(owner, {}, null, {
    showMask: false,
    showError: false
  }).then(res => {
    let totalCount = res.data.copyMessageCount + res.data.remindingMessageCount
    if (state.messageCount.totalCount < totalCount){
      notify.close()
      notify.setFavicon(1).player()
      notify.notify({})
    }
    context.commit('setMessageCount', res.data);
  }).catch(e => {
    console.error(e);
  });
}

// 获得消息列表数据
function loadEmailMessage (context, owner) {
  FlowOperationController.getEmailCount(owner, {}, null, {
    showMask: false,
    showError: false
  }).then(res => {
    if (state.unReadCount < res.data.unReadMessageCount) {
      EmailNotify.close()
      EmailNotify.setFavicon(1).player()
      EmailNotify.notify({})
    }
    context.commit('setEmailCount', res.data.unReadMessageCount);
  }).catch(e => {
    console.error(e);
  });
}
export default {
  startMessage: (context, owner) => {
    if (context.state.messageTimer != null) {
      clearInterval(context.state.messageTimer);
    }

    let timer = setInterval(() => {
      loadMessage(context, owner);
      loadEmailMessage(context, owner)
    }, MESSAGE_TIMER_INTERVAL);
    context.commit('setMessageTimer', timer);
    loadMessage(context, owner);
    loadEmailMessage(context, owner);
  },
  stopMessage: (context) => {
    if (context.state.messageTimer != null) {
      clearInterval(context.state.messageTimer);
    }
    context.commit('setMessageTimer', null);
  },
  reloadMessage: (context, owner) => {
    loadMessage(context, owner);
  }
}
